/* eslint-disable no-useless-catch,@typescript-eslint/no-non-null-assertion,@typescript-eslint/no-non-null-asserted-optional-chain */
import { createStore } from '../../../util/mobx/generic-store/store-creator'
import { GenericStoreAsyncMethod } from '../../../util/mobx/generic-store/decorator/async-method.decorator'
import { GenericStore } from '../../../util/mobx/generic-store/generic.store'
import { deleteOrganisationUser, deleteUserInvite, getInvites, getSystemSettings, getUsers, GetUsersParams, postAddUser, postOrganisationUser, postResendUserInvite, postSystemSettings, postUserInvite, saveSiteMap } from '../api/admin'
import { SiteMap } from 'src/feature/user/model/SiteMap'
import { OrganisationUser } from '../model/OrganisationUser'
import { SystemSettings } from '../model/SystemSettings'
import { OrganisationInvite } from '../model/OrganisationInvite'
import { OrganisationRole } from '../model/OrganisationRole'

export class ControlPanelStore extends GenericStore {
  users!: OrganisationUser[]
  usersTotal!: number
  userInvites!: OrganisationInvite[]
  systemSettings?: SystemSettings

  constructor() {
    super('ControlPanelStore')

    super.observe(this)
    this.reset()
    super.persist({ encrypt: false, excludedProperties: ['users', 'userInvites'] })
  }

  reset() {
    this.users = []
    this.usersTotal = 0
    this.userInvites = []
    this.systemSettings = undefined
  }

  @GenericStoreAsyncMethod()
  async saveSiteMap(sitemap: SiteMap) {
    await saveSiteMap(sitemap)
  }

  @GenericStoreAsyncMethod()
  async updateOrganisationUsers(params: GetUsersParams = {}) {
    const { users, total } = await getUsers(params)
    this.users = users
    this.usersTotal = total
    this.userInvites = await getInvites()
  }

  @GenericStoreAsyncMethod()
  async updateOrgUser(userId: string, groups: string[], role: OrganisationRole, subscriptionPlan: number) {
    await postOrganisationUser(userId, groups, role, subscriptionPlan)
  }

  @GenericStoreAsyncMethod()
  async removeOrgUser(userId: string) {
    await deleteOrganisationUser(userId)
  }

  @GenericStoreAsyncMethod()
  async inviteUser(email: string, groups: string[], role: OrganisationRole) {
    await postUserInvite(email, groups, role)
  }

  @GenericStoreAsyncMethod()
  async addUser(email: string, groups: string[], role: OrganisationRole) {
    await postAddUser(email, groups, role)
  }

  @GenericStoreAsyncMethod()
  async deleteInvite(inviteId: string) {
    await deleteUserInvite(inviteId)
  }

  @GenericStoreAsyncMethod()
  async resendInvite(inviteId: string) {
    await postResendUserInvite(inviteId)
  }

  @GenericStoreAsyncMethod()
  async loadSystemSettings() {
    this.systemSettings = await getSystemSettings()
  }

  @GenericStoreAsyncMethod()
  async saveSystemSettings(systemSettings: SystemSettings) {
    await postSystemSettings(systemSettings)
    this.systemSettings = systemSettings
  }
}

export const {
  storeInstance: controlPanelStoreInstance,
  useStore: useControlPanelStore,
  StoreProvider: ControlPanelStoreProvider,
} = createStore(new ControlPanelStore())
